var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popconfirm',{attrs:{"title":"确定要退出吗？"},on:{"confirm":_vm.logout}},[_c('el-button',{attrs:{"slot":"reference","type":"text","icon":"el-icon-switch-button"},slot:"reference"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }